import jQuery from 'jquery';
import {TweenLite, Power2} from 'gsap';

function goTo(href) {
	if (href.indexOf('#') === -1) {
		TweenLite.to('#preloader', 0.2, {height: '100%', 'pointer-events': 'default', ease: Power2.easeOut});
		TweenLite.to('.img-holder', 0.3, {height: '50px', ease: Power2.easeOut, delay: 0.5});

		setTimeout(function () {
			window.location = href;
		}, 800);
	}
	return false;
}

export default () => {
  jQuery('body').removeClass('no-load');

  TweenLite.to('.img-holder', 0.3, {height: 0, ease: Power2.easeOut});
  TweenLite.to('#preloader', 0.3, {height: 0, 'pointer-events': 'none', ease: Power2.easeOut, delay: 0.2});
  TweenLite.from('header', 0.2, {transform: 'translateY(-200px)', ease: Power2.easeOut, delay: 0.9});

  jQuery(window).bind('pageshow', function (event) {
    if (event.originalEvent.persisted) {
      window.location.reload();
    }
  });

  let activeHref = null;

  jQuery(document).on('click', 'a', function (){
    let href = jQuery(this).attr('href');
		goTo(href);
  });

	jQuery(document).on('touchstart', 'a', function (){
		activeHref = jQuery(this).attr('href');
	});

	jQuery(document).on('touchmove', 'a', function (){
		activeHref = null
	});

	jQuery(document).on('touchend', 'a', function (){
		if (activeHref !== null) {
		  goTo(activeHref);
    }
	});
};




// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/fade-out.js